import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../client';
import { initializeKeys } from '../query-keys';
import { useAuthStore } from '@/stores/auth-store';
import {
  getInitializeSummaryContract,
  type GetInitializeSummaryResponse
} from '@bliks-io/contracts';

/**
 * Overview counts for the initial-setup wizard's final step.
 */
export function useInitializeSummary() {
  const { token } = useAuthStore();

  return useQuery({
    queryKey: initializeKeys.summary(),
    queryFn: async ({ signal }): Promise<GetInitializeSummaryResponse> => {
      const { data } = await apiClient.get<GetInitializeSummaryResponse>(
        getInitializeSummaryContract.path,
        { signal }
      );
      return data;
    },
    enabled: !!token
  });
}
